<div class="zeroPadding" *ngFor="let merchant of results">
  <div class="row searchResultsRow" (click)="selectMerchant(merchant)">
    <div class="col-md-11 ">
      <div class="searchResultName">
        <div>{{ merchant.descriptionLong }}</div>
      </div>
      <div class="searchResultDataName">
        Location:
        <span class="searchResultDataVal"
          >{{ merchant.shipName }}({{ merchant.location }})</span
        >
        | Card Number:
        <span class="searchResultDataVal">{{
          merchant.cardNum | threeStars
        }}</span>
        | Type: <span class="searchResultDataVal">{{ merchant.type }}</span>
      </div>
    </div>
  </div>
</div>
